import { Skeleton } from 'antd';
import React from 'react';

import Filter from '../components/Filter/Filter';
import Table from '../components/Table/Table';

import { getIntegrationTypesConstant } from 'utils/general';
const { HOTEL_TYPE } = getIntegrationTypesConstant();

const HotelIntegration = ({
  isLoadingDefaultData,
  isLoadingHotelsIntegration,
  otaSyncStatusConstants,
  propertyOptions,
  hostOptions,
  hotelIntegrations,
  selectedPropertyId,
  selectedPropertyHostId,
  onChangeProperty,
  onChangeHost,
  onClickButtonCreateEdit,
  onClickButtonDelete,
  checkIsAdmin
}) => {
  return (
    <Skeleton active loading={isLoadingDefaultData}>
      <Filter
        type={HOTEL_TYPE.code}
        propertyOptions={propertyOptions}
        hostOptions={hostOptions}
        selectedPropertyId={selectedPropertyId}
        selectedPropertyHostId={selectedPropertyHostId}
        onChangeProperty={onChangeProperty}
        onChangeHost={onChangeHost}
        checkIsAdmin={checkIsAdmin}
      />
      <Skeleton active loading={isLoadingHotelsIntegration}>
        <Table
          otaSyncStatusConstants={otaSyncStatusConstants}
          integrations={hotelIntegrations}
          type={HOTEL_TYPE.code}
          onClickButtonCreateEdit={onClickButtonCreateEdit}
          onClickButtonDelete={onClickButtonDelete}
        />
      </Skeleton>
    </Skeleton>
  );
};

export default HotelIntegration;
